import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface GestionStockTabCounts {
  actif: number;
  archive: number;
}

@Injectable({ providedIn: 'root' })
export class LogicielCaisseGestionStockStateService {
  private readonly countsSubject = new BehaviorSubject<GestionStockTabCounts>({
    actif: 0,
    archive: 0,
  });

  readonly counts$ = this.countsSubject.asObservable();

  setCounts(counts: GestionStockTabCounts): void {
    this.countsSubject.next(counts);
  }
}
